/**
 * Template for creating new exercises
 */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  wrapper: {
    height: '100%',
    overflow: 'auto',
    '& > div': {
      width: 700,
      maxWidth: '100%',
      background: '#fff',
      padding: 20,
      margin: '20px auto',
    },
    '& h3': {
      color: theme.palette.primary.main,
      textAlign: 'center',
      marginTop: 0,
    },
  },
  table: {
    borderSpacing: 0,
    cellSpacing: 0,
    borderCollapse: 'collapse',
    width: '100%',
    '& th': {
      border: '1px solid #eee',
      padding: '0 8px',
      background: '#ecf0ff',
      color: '#203383',
      '&.comer-title': {
        fontSize: '1.25em',
        padding: 8,
        background: '#e1e5f7',
      },
    },
    '& td': {
      border: '1px solid #eee',
      padding: '0 8px',
      color: '#203383',
      '& span': {
        textDecoration: 'underline',
      },
    },
  },

  '@media(max-width: 850px)': {

  }
}));

function Comer() {
  const classes = useStyles();

  return (
    <div className={classes.wrapper}>
      <div>
        <h3>Comer (jeść)</h3>
        <table className={classes.table}>
          <tbody>
            <tr><th colSpan={2} className="comer-title">Tryb <i>Indicativo</i></th></tr>

            <tr><th>&nbsp;</th><th>Czas tereaźniejszy (<i>Presente</i>)</th></tr>
            <tr><td>yo</td><td>com<span>o</span></td></tr>
            <tr><td>tú</td><td>com<span>es</span></td></tr>
            <tr><td>él, ella, Ud.</td><td>com<span>e</span></td></tr>
            <tr><td>nosotros</td><td>com<span>emos</span></td></tr>
            <tr><td>vosotros</td><td>com<span>eis</span></td></tr>
            <tr><td>ellos, ellas, Uds.</td><td>com<span>en</span></td></tr>

            <tr><th>&nbsp;</th><th>Czas przeszły niedokonany (<i>Imperfecto</i>)</th></tr>
            <tr><td>yo</td><td>com<span>ía</span></td></tr>
            <tr><td>tú</td><td>com<span>ías</span></td></tr>
            <tr><td>él, ella, Ud.</td><td>com<span>ía</span></td></tr>
            <tr><td>nosotros</td><td>com<span>íamos</span></td></tr>
            <tr><td>vosotros</td><td>com<span>íais</span></td></tr>
            <tr><td>ellos, ellas, Uds.</td><td>com<span>ían</span></td></tr>

            <tr><th>&nbsp;</th><th>Czas przeszły dokonany (<i>Indefinido</i>)</th></tr>
            <tr><td>yo</td><td>com<span>í</span></td></tr>
            <tr><td>tú</td><td>com<span>iste</span></td></tr>
            <tr><td>él, ella, Ud.</td><td>com<span>ió</span></td></tr>
            <tr><td>nosotros</td><td>com<span>imos</span></td></tr>
            <tr><td>vosotros</td><td>com<span>isteis</span></td></tr>
            <tr><td>ellos, ellas, Uds.</td><td>com<span>ieron</span></td></tr>

            <tr><th>&nbsp;</th><th>Czas przeszły złożony (<i>Pretérito Perfecto</i>)</th></tr>
            <tr><td>yo</td><td>he comido</td></tr>
            <tr><td>tú</td><td>has comido</td></tr>
            <tr><td>él, ella, Ud.</td><td>ha comido</td></tr>
            <tr><td>nosotros</td><td>hemos comido</td></tr>
            <tr><td>vosotros</td><td>habéis comido</td></tr>
            <tr><td>ellos, ellas, Uds.</td><td>han comido</td></tr>

            <tr><th>&nbsp;</th><th>Czas zaprzeszły (<i>Pluscuamperfecto</i>)</th></tr>
            <tr><td>yo</td><td>había comido</td></tr>
            <tr><td>tú</td><td>habías comido</td></tr>
            <tr><td>él, ella, Ud.</td><td>había comido</td></tr>
            <tr><td>nosotros</td><td>habíamos comido</td></tr>
            <tr><td>vosotros</td><td>habíais comido</td></tr>
            <tr><td>ellos, ellas, Uds.</td><td>habían comido</td></tr>

            <tr><th>&nbsp;</th><th>Czas przyszły prosty (<i>Futuro</i>)</th></tr>
            <tr><td>yo</td><td>comer<span>é</span></td></tr>
            <tr><td>tú</td><td>comer<span>ás</span></td></tr>
            <tr><td>él, ella, Ud.</td><td>comer<span>á</span></td></tr>
            <tr><td>nosotros</td><td>comer<span>emos</span></td></tr>
            <tr><td>vosotros</td><td>comer<span>éis</span></td></tr>
            <tr><td>ellos, ellas, Uds.</td><td>comer<span>án</span></td></tr>

            <tr><th>&nbsp;</th><th>Czas przyszły złożony (<i>Futuro perfecto</i>)</th></tr>
            <tr><td>yo</td><td>habré comido</td></tr>
            <tr><td>tú</td><td>habrás comido</td></tr>
            <tr><td>él, ella, Ud.</td><td>habrá comido</td></tr>
            <tr><td>nosotros</td><td>habremos comido</td></tr>
            <tr><td>vosotros</td><td>habréis comido</td></tr>
            <tr><td>ellos, ellas, Uds.</td><td>habrán comido</td></tr>

            <tr><th>&nbsp;</th><th>Tryb przypuszczający (<i>Condicional</i>)</th></tr>
            <tr><td>yo</td><td>comer<span>ía</span></td></tr>
            <tr><td>tú</td><td>comer<span>ías</span></td></tr>
            <tr><td>él, ella, Ud.</td><td>comer<span>ía</span></td></tr>
            <tr><td>nosotros</td><td>comer<span>íamos</span></td></tr>
            <tr><td>vosotros</td><td>comer<span>íais</span></td></tr>
            <tr><td>ellos, ellas, Uds.</td><td>comer<span>ían</span></td></tr>

            <tr><th>&nbsp;</th><th>Tryb przypuszczający złożony (<i>Condicional cumpuesto</i>)</th></tr>
            <tr><td>yo</td><td>habría comido</td></tr>
            <tr><td>tú</td><td>habrías comido</td></tr>
            <tr><td>él, ella, Ud.</td><td>habría comido</td></tr>
            <tr><td>nosotros</td><td>habríamos comido</td></tr>
            <tr><td>vosotros</td><td>habríais comido</td></tr>
            <tr><td>ellos, ellas, Uds.</td><td>habrían comido</td></tr>

            <tr><th colSpan={2} className="comer-title">Tryb <i>Subjuntivo</i></th></tr>

            <tr><th>&nbsp;</th><th><i>Presente de subjuntivo</i></th></tr>
            <tr><td>yo</td><td>com<span>a</span></td></tr>
            <tr><td>tú</td><td>com<span>as</span></td></tr>
            <tr><td>él, ella, Ud.</td><td>com<span>a</span></td></tr>
            <tr><td>nosotros</td><td>com<span>amos</span></td></tr>
            <tr><td>vosotros</td><td>com<span>áis</span></td></tr>
            <tr><td>ellos, ellas, Uds.</td><td>com<span>an</span></td></tr>

            <tr><th>&nbsp;</th><th><i>Imperfecto de subjuntivo</i></th></tr>
            <tr><td>yo</td><td>com<span>iera</span></td></tr>
            <tr><td>tú</td><td>com<span>ieras</span></td></tr>
            <tr><td>él, ella, Ud.</td><td>com<span>iera</span></td></tr>
            <tr><td>nosotros</td><td>com<span>iéramos</span></td></tr>
            <tr><td>vosotros</td><td>com<span>ierais</span></td></tr>
            <tr><td>ellos, ellas, Uds.</td><td>com<span>ieran</span></td></tr>

            <tr><th>&nbsp;</th><th><i>Pretérito perfecto de subjuntivo</i></th></tr>
            <tr><td>yo</td><td>haya comido</td></tr>
            <tr><td>tú</td><td>hayas comido</td></tr>
            <tr><td>él, ella, Ud.</td><td>haya comido</td></tr>
            <tr><td>nosotros</td><td>hayamos comido</td></tr>
            <tr><td>vosotros</td><td>hayáis comido</td></tr>
            <tr><td>ellos, ellas, Uds.</td><td>hayan comido</td></tr>

            <tr><th>&nbsp;</th><th><i>Pluscuamperfecto de subjuntivo</i></th></tr>
            <tr><td>yo</td><td>hubiera comido</td></tr>
            <tr><td>tú</td><td>hubieras comido</td></tr>
            <tr><td>él, ella, Ud.</td><td>hubiera comido</td></tr>
            <tr><td>nosotros</td><td>hubiéramos comido</td></tr>
            <tr><td>vosotros</td><td>hubierais comido</td></tr>
            <tr><td>ellos, ellas, Uds.</td><td>hubieran comido</td></tr>

            <tr><th colSpan={2} className="comer-title">Tryb rozkazujący <i>Imerativo</i></th></tr>

            <tr><th>&nbsp;</th><th>Afirmativo</th></tr>
            <tr><td>yo</td><td>-</td></tr>
            <tr><td>tú</td><td>com<span>e</span></td></tr>
            <tr><td>él, ella, Ud.</td><td>com<span>a</span></td></tr>
            <tr><td>nosotros</td><td>com<span>amos</span></td></tr>
            <tr><td>vosotros</td><td>com<span>ed</span></td></tr>
            <tr><td>ellos, ellas, Uds.</td><td>com<span>an</span></td></tr>

            <tr><th>&nbsp;</th><th>Negativo</th></tr>
            <tr><td>yo</td><td>-</td></tr>
            <tr><td>tú</td><td>no com<span>as</span></td></tr>
            <tr><td>él, ella, Ud.</td><td>no com<span>a</span></td></tr>
            <tr><td>nosotros</td><td>no com<span>amos</span></td></tr>
            <tr><td>vosotros</td><td>no com<span>áis</span></td></tr>
            <tr><td>ellos, ellas, Uds.</td><td>no com<span>an</span></td></tr>

          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Comer;